module.exports = __webpack_public_path__ + "static/media/DougBarton.175599d0.jpg";